import { Alert, Button, EmptyState, ErrorState, Skeleton } from '@indipia/ui-core'
import type { ScheduleListBlockError } from '../../hooks/useScheduleListData'

// 로딩·빈·오류 상태(계획서 D-01 상태 표시 부분) — Skeleton · EmptyState · ErrorState · Alert.
// 로딩은 Skeleton, 0건은 EmptyState, 실패는 폴백 없이 명시 오류 + [다시 시도]. 값을 만들어 채우지 않는다.

const SKELETON_ROWS = 6

/** 로딩 — 표 모양 Skeleton */
export function ScheduleListLoading() {
  return (
    <div role="status" aria-label="리스트를 불러오는 중" style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-03)', padding: 'var(--spacing-05)' }}>
      <Skeleton height="var(--num-40)" />
      {Array.from({ length: SKELETON_ROWS }, (_, i) => <Skeleton key={i} height="var(--num-56)" />)}
    </div>
  )
}

/** 공종 0건(필터 통과 0건이 아니라 현장에 공종이 하나도 없음) */
export function ScheduleListEmpty() {
  return <EmptyState title="등록된 공종이 없어요" />
}

const BLOCK_ERROR_TITLE: Record<ScheduleListBlockError['kind'], string> = {
  detail: '스케줄을 불러오지 못했어요',
  signal: '신호 정보를 불러오지 못했어요',
}

/** 표 전체를 대신하는 오류(공종 조회 실패 · 신호 조회 실패) */
export function ScheduleListBlockErrorView({ error }: { error: ScheduleListBlockError }) {
  return <ErrorState title={BLOCK_ERROR_TITLE[error.kind]} onRetry={error.retry} />
}

export interface ScheduleListPartialAlertsProps {
  ordersFailed: boolean
  onRetryOrders: () => void
  milestonesFailed: boolean
  onRetryMilestones: () => void
}

/** 부분 오류 — 발주 칸·마일스톤 행만 실패한 경우 표 위에 한 줄씩 안내(표는 그대로 그린다) */
export function ScheduleListPartialAlerts({ ordersFailed, onRetryOrders, milestonesFailed, onRetryMilestones }: ScheduleListPartialAlertsProps) {
  if (!ordersFailed && !milestonesFailed) return null
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-02)', padding: 'var(--spacing-03) var(--spacing-05)' }}>
      {ordersFailed && (
        <Alert kind="warning" action={<Button variant="secondary" size="sm" onClick={onRetryOrders}>다시 시도</Button>}>
          발주 정보를 불러오지 못해 발주 칸을 표시할 수 없어요
        </Alert>
      )}
      {milestonesFailed && (
        <Alert kind="warning" action={<Button variant="secondary" size="sm" onClick={onRetryMilestones}>다시 시도</Button>}>
          마일스톤을 불러오지 못했어요
        </Alert>
      )}
    </div>
  )
}
